module.exports = __webpack_public_path__ + "static/media/logo-foreign-modal.d55b826a.svg";